const UIStates = {
    UI_MOBILE_MENU_HIDDEN: 'UI_MOBILE_MENU_HIDDEN',
    UI_MOBILE_MENU_SHOWN: 'UI_MOBILE_MENU_SHOWN',

    UI_ROUTE_CHANGED: 'UI_ROUTE_CHANGED',

    UI_BREADCRUMB_PUSHED: 'UI_BREADCRUMB_PUSHED',
    UI_BREADCRUMB_POPPED: 'UI_BREADCRUMB_POPPED',
    UI_BREADCRUMBS_CLEANED: 'UI_BREADCRUMBS_CLEANED',

    UI_CONTEXT_MENU_CONTAINER_BOUNDARIES: 'UI_CONTEXT_MENU_CONTAINER_BOUNDARIES'
};

const UIActions = {

    UI_SHOW_MOBILE_MENU: 'UI_SHOW_MOBILE_MENU',
    UI_HIDE_MOBILE_MENU: 'UI_HIDE_MOBILE_MENU',

    UI_CHANGE_ROUTE: 'UI_CHANGE_ROUTE',
    UI_PUSH_BREADCRUMB: 'UI_PUSH_BREADCRUMB',
    UI_POP_BREADCRUMB: 'UI_POP_BREADCRUMB',
    UI_CLEAN_BREADCRUMBS: 'UI_CLEAN_BREADCRUMBS',

    UI_CONTEXT_MENU_CONTAINER_SET_BOUNDARIES: 'UI_CONTEXT_MENU_CONTAINER_SET_BOUNDARIES'
};

export default {
    UIStates: UIStates,
    UIActions: UIActions
};